module.exports = __webpack_public_path__ + "img/onlineTrainerSign.bc2523c0.png";